(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["JGNT-Marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function build(marquee) {
      var track = marquee.querySelector('.jgnt-marquee__track');
      var set = track && track.querySelector('.jgnt-marquee__set');
      if (!set) return;

      // Eliminar clones previos (recalculos / resize / editor)
      var oldClones = track.querySelectorAll('.jgnt-marquee__set--clone');
      for (var i = 0; i < oldClones.length; i++) { oldClones[i].remove(); }

      // Restaurar contenido base del set
      if (set.dataset.base == null) {
        set.dataset.base = set.innerHTML;
      } else {
        set.innerHTML = set.dataset.base;
      }

      var containerW = marquee.clientWidth;
      if (!containerW) return;
      if (!set.innerHTML.trim()) return;

      // Repetir items hasta cubrir el ancho visible (evita huecos con poco contenido)
      var itemsHTML = set.innerHTML;
      var guard = 0;
      while (set.scrollWidth < containerW && guard < 60) {
        set.insertAdjacentHTML('beforeend', itemsHTML);
        guard++;
      }

      // Clonar el set completo para un loop continuo (translateX -50%)
      var clone = set.cloneNode(true);
      clone.classList.add('jgnt-marquee__set--clone');
      clone.setAttribute('aria-hidden', 'true');
      var editorNodes = clone.querySelectorAll('[data-shopify-editor-block]');
      for (var j = 0; j < editorNodes.length; j++) {
        editorNodes[j].removeAttribute('data-shopify-editor-block');
      }
      track.appendChild(clone);

      // Velocidad constante (px por segundo), independiente del contenido
      var setW = clone.offsetLeft - set.offsetLeft;
      if (setW <= 0) setW = set.scrollWidth;
      var speed = parseFloat(marquee.getAttribute('data-speed')) || 60;
      // Solo fijar duracion si la medida es valida; si no, se queda el respaldo de 30s del CSS
      if (setW > 0 && speed > 0) {
        track.style.animationDuration = (setW / speed) + 's';
      }
    }

    function buildAll() {
      var bars = document.querySelectorAll('.jgnt-marquee');
      for (var i = 0; i < bars.length; i++) { build(bars[i]); }
    }

    if (document.readyState !== 'loading') {
      buildAll();
    } else {
      document.addEventListener('DOMContentLoaded', buildAll);
    }

    // Recalcular cuando cargue todo (imagenes) y cuando la fuente propia este lista
    window.addEventListener('load', buildAll);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(buildAll);
    }

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(buildAll, 200);
    });

    // Editor de temas
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.jgnt-marquee');
      if (el) build(el);
    });
    document.addEventListener('shopify:section:select', function (e) {
      var el = e.target.querySelector('.jgnt-marquee');
      if (el) build(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
